import { render } from "./EmailIcon.vue?vue&type=template&id=5688459b"
import script from "./EmailIcon.vue?vue&type=script&lang=js"
export * from "./EmailIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__